import { render, staticRenderFns } from "./MultipleResponseQuestion.vue?vue&type=template&id=402159ee&"
import script from "./MultipleResponseQuestion.vue?vue&type=script&lang=js&"
export * from "./MultipleResponseQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports